/* ============================================
   OPTIMAL NATIVE — SHOPIFY THEME JS
   ============================================ */

document.addEventListener('DOMContentLoaded', function() {
  // Translations from layout/theme.liquid (window.ON_I18N.theme); English fallback.
  function onT(key, fallback) {
    var t = window.ON_I18N && window.ON_I18N.theme;
    return t && typeof t[key] === 'string' ? t[key] : fallback;
  }

  // ── CUSTOM CURSOR ────────────────────────────────────
  var cur = document.getElementById('on-cursor');
  var ring = document.getElementById('on-cursor-ring');
  if (cur && ring) {
    var mx = 0, my = 0, rx = 0, ry = 0;
    document.addEventListener('mousemove', function(e) {
      mx = e.clientX; my = e.clientY;
      cur.style.left = mx + 'px';
      cur.style.top  = my + 'px';
    });
    function animRing() {
      rx += (mx - rx) * 0.1;
      ry += (my - ry) * 0.1;
      ring.style.left = rx + 'px';
      ring.style.top  = ry + 'px';
      requestAnimationFrame(animRing);
    }
    animRing();
  }

  // ── STICKY NAV ───────────────────────────────────────
  var header = document.getElementById('site-header');
  if (header) {
    window.addEventListener('scroll', function() {
      header.classList.toggle('scrolled', window.scrollY > 60);
    });
  }

  // ── ANCHOR SCROLL WITH HEADER OFFSET ───────────────
  function scrollToAnchorHash(hash) {
    if (!hash || hash.length < 2) return false;
    var target = document.getElementById(hash.slice(1));
    if (!target) return false;

    var headerOffset = header ? header.offsetHeight : 0;
    var top = target.getBoundingClientRect().top + window.scrollY - headerOffset - 8;
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    return true;
  }

  document.querySelectorAll('a[href*="#"]').forEach(function(link) {
    link.addEventListener('click', function(e) {
      var rawHref = link.getAttribute('href');
      if (!rawHref || rawHref.charAt(0) === '#') {
        if (rawHref && rawHref.length > 1) {
          if (scrollToAnchorHash(rawHref)) {
            e.preventDefault();
          }
        }
        return;
      }

      var parsed;
      try {
        parsed = new URL(rawHref, window.location.origin);
      } catch (_) {
        return;
      }

      if (!parsed.hash) return;

      var currentPath = window.location.pathname.replace(/\/$/, '');
      var targetPath = parsed.pathname.replace(/\/$/, '');
      if (currentPath === targetPath) {
        if (scrollToAnchorHash(parsed.hash)) {
          e.preventDefault();
        }
      }
    });
  });

  if (window.location.hash) {
    setTimeout(function() {
      scrollToAnchorHash(window.location.hash);
    }, 60);
  }

  // ── MOBILE MENU ──────────────────────────────────────
  var toggle = document.getElementById('nav-toggle');
  var mobileNav = document.getElementById('mobile-nav');
  var mobileClose = document.getElementById('mobile-nav-close');
  if (toggle && mobileNav) {
    function openMobileNav() {
      mobileNav.classList.add('open');
      toggle.classList.add('is-active');
      toggle.setAttribute('aria-expanded', 'true');
      toggle.setAttribute('aria-label', onT('closeMenu', 'Close menu'));
      document.body.style.overflow = 'hidden';
    }

    function closeMobileNav() {
      mobileNav.classList.remove('open');
      toggle.classList.remove('is-active');
      toggle.setAttribute('aria-expanded', 'false');
      toggle.setAttribute('aria-label', onT('openMenu', 'Open menu'));
      document.body.style.overflow = '';
    }

    toggle.addEventListener('click', function() {
      if (mobileNav.classList.contains('open')) {
        closeMobileNav();
      } else {
        openMobileNav();
      }
    });

    if (mobileClose) {
      mobileClose.addEventListener('click', function() {
        closeMobileNav();
      });
    }

    mobileNav.addEventListener('click', function(e) {
      if (e.target === mobileNav) {
        closeMobileNav();
      }
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && mobileNav.classList.contains('open')) {
        closeMobileNav();
      }
    });

    mobileNav.querySelectorAll('a').forEach(function(a) {
      a.addEventListener('click', function() {
        closeMobileNav();
      });
    });
  }

  // ── SCROLL REVEAL ────────────────────────────────────
  var revealObs = new IntersectionObserver(function(entries) {
    entries.forEach(function(e, i) {
      if (e.isIntersecting) {
        setTimeout(function() {
          e.target.classList.add('vis');
        }, i * 80);
        revealObs.unobserve(e.target);
      }
    });
  }, { threshold: 0.06 });

  document.querySelectorAll('.reveal, .reveal-left, .reveal-right').forEach(function(el) {
    revealObs.observe(el);
  });

  // ── TIMELINE BAR ─────────────────────────────────────
  var tbar = document.getElementById('timeline-fill');
  if (tbar) {
    window.addEventListener('scroll', function() {
      var section = document.getElementById('timeline-section');
      if (!section) return;
      var r = section.getBoundingClientRect();
      var pct = Math.max(0, Math.min(1, (window.innerHeight - r.top) / (window.innerHeight + r.height)));
      tbar.style.width = (pct * 100) + '%';
    });
  }

  // ── FAQ ACCORDION ────────────────────────────────────
  function toggleFaq(btn) {
    var item = btn.closest('.faq-item');
    var isOpen = item.classList.contains('open');
    document.querySelectorAll('.faq-item.open').forEach(function(i) {
      i.classList.remove('open');
    });
    if (!isOpen) {
      item.classList.add('open');
      btn.setAttribute('aria-expanded', 'true');
    } else {
      btn.setAttribute('aria-expanded', 'false');
    }
  }
  // Expose globally for onclick attributes
  window.toggleFaq = toggleFaq;

  // Also wire via event listeners (works both ways)
  document.querySelectorAll('.faq-btn').forEach(function(btn) {
    btn.addEventListener('click', function() { toggleFaq(btn); });
  });

  // ── EFFECT BARS ANIMATION ────────────────────────────
  var barSection = document.querySelector('.pdp-effects');
  if (barSection) {
    var barObs = new IntersectionObserver(function(entries) {
      if (entries[0].isIntersecting) {
        barSection.querySelectorAll('.effect-bar-fill').forEach(function(bar) {
          bar.style.width = bar.getAttribute('data-width') || '80%';
        });
        barObs.unobserve(barSection);
      }
    }, { threshold: 0.3 });
    barObs.observe(barSection);
  }

  // ── PDP: FLAVOR SELECTOR ─────────────────────────────
  var pdpData = window.ON_PRODUCTS || {};
  var currentSku  = Object.keys(pdpData)[0] || null;
  function pdpSelectFlavor(sku) {
    if (!pdpData[sku]) return;
    currentSku = sku;
    var p = pdpData[sku];

    var titleEl = document.getElementById('pdp-title');
    var tagEl   = document.getElementById('pdp-sku-tag');
    var descEl  = document.getElementById('pdp-tagline');
    var mainImg = document.getElementById('pdp-can-main');

    if (titleEl) titleEl.innerHTML = p.title;
    if (tagEl)   { tagEl.textContent = p.skuLabel; tagEl.style.color = p.color; }
    if (descEl)  descEl.textContent = p.tagline;

    if (mainImg) {
      mainImg.classList.add('changing');
      setTimeout(function() {
        mainImg.src = p.img;
        mainImg.classList.remove('changing');
      }, 200);
    }

    // Update flavor cards
    document.querySelectorAll('.flavor-card').forEach(function(c) {
      c.classList.toggle('selected', c.getAttribute('data-sku') === sku);
    });

    // Update thumbnails
    document.querySelectorAll('.pdp-thumb').forEach(function(t) {
      t.classList.toggle('active', t.getAttribute('data-sku') === sku);
    });

    pdpRenderIngredients(sku);
    pdpRenderTimeline(sku);
  }

  function pdpAddToCart() {
    var btn = document.getElementById('btn-add-cart');
    if (!btn) return;
    var orig = btn.innerHTML;

    // Find Appstle's native submit button (bundle + subscription aware).
    // Appstle Bundle & Upsell renders inside the @app block; we proxy the click
    // so Appstle handles its own bundle line-item properties and selling plans.
    var appstleBtn =
      document.querySelector('[class*="appstle"][class*="atc"]') ||
      document.querySelector('[data-appstle-atc]') ||
      document.querySelector('[id*="appstle"] button[type="submit"]') ||
      document.querySelector('[class*="appstle"] button[type="submit"]') ||
      document.querySelector('.appstle-bundle-app button[type="submit"]') ||
      document.querySelector('.appstle-subscription-widget button[type="submit"]');

    if (appstleBtn) {
      btn.disabled = true;
      btn.textContent = onT('adding', 'Adding…');
      var countBefore = cartCount;
      appstleBtn.click();
      // Poll /cart.js until the count changes (Appstle finished) or 3 s pass
      var tries = 0;
      var poll = setInterval(function() {
        tries++;
        fetch('/cart.js')
          .then(function(r) { return r.json(); })
          .then(function(cart) {
            if (cart.item_count !== countBefore || tries >= 6) {
              clearInterval(poll);
              cartCount = cart.item_count;
              updateCartUI();
              btn.textContent = onT('addedToCart', '✓ Added to Cart');
              btn.style.background = '#22c55e';
              btn.style.color = '#fff';
              setTimeout(function() {
                btn.innerHTML = orig;
                btn.style.background = '';
                btn.style.color = '';
                btn.disabled = false;
              }, 2000);
            }
          })
          .catch(function() {
            clearInterval(poll);
            btn.innerHTML = orig;
            btn.disabled = false;
          });
      }, 500);
      return;
    }

    // Fallback: direct cart add — reads selling_plan from any Appstle input
    if (!currentSku) return;
    btn.disabled = true;
    btn.textContent = onT('adding', 'Adding…');

    var addItem = { id: parseInt(currentSku, 10), quantity: qty };
    var planEl = document.querySelector(
      'select[name="selling_plan"], input[name="selling_plan"]:checked, input[name="selling_plan"][type="hidden"]'
    );
    if (planEl && planEl.value) addItem.selling_plan = planEl.value;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [addItem] })
    })
    .then(function(r) { return r.json(); })
    .then(function(data) {
      if (data.status && data.status !== 200) return Promise.reject(data);
      btn.textContent = onT('addedToCart', '✓ Added to Cart');
      btn.style.background = '#22c55e';
      btn.style.color = '#fff';
      fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
        cartCount = cart.item_count;
        updateCartUI();
      });
      setTimeout(function() {
        btn.innerHTML = orig;
        btn.style.background = '';
        btn.style.color = '';
        btn.disabled = false;
      }, 2200);
    })
    .catch(function(err) {
      var msg = (err && (err.description || err.message)) || onT('errorTryAgain', 'Error — try again');
      btn.textContent = String(msg).slice(0, 60);
      btn.style.background = '#ef4444';
      btn.style.color = '#fff';
      setTimeout(function() {
        btn.innerHTML = orig;
        btn.style.background = '';
        btn.style.color = '';
        btn.disabled = false;
      }, 2500);
    });
  }

  function pdpRenderIngredients(sku) {
    var list = document.getElementById('pdp-ingredient-list');
    if (!list || !pdpData[sku]) return;
    var ings = pdpData[sku].ingredients || [];
    list.innerHTML = ings.map(function(i) {
      return '<div class="ing-row"><div><div class="ing-name">' + i.name + '</div><div class="ing-desc">' + i.desc + '</div></div><div class="ing-dose" style="color:' + (pdpData[sku].color || '#fff') + '">' + i.dose + '</div></div>';
    }).join('');
  }

  function pdpRenderTimeline(sku) {
    var steps = document.getElementById('effect-steps');
    if (!steps || !pdpData[sku]) return;
    var tl = pdpData[sku].timeline || [];
    steps.innerHTML = tl.map(function(s) {
      return '<div class="effect-step"><div class="effect-time">' + s.time + '</div><div><div class="effect-head">' + s.head + '</div><div class="effect-desc">' + s.desc + '</div></div></div>';
    }).join('');
  }

  function pdpSwitchTab(id, btn) {
    document.querySelectorAll('.pdp-tab-content').forEach(function(t) { t.classList.remove('active'); });
    document.querySelectorAll('.pdp-tab-btn').forEach(function(b) { b.classList.remove('active'); });
    var el = document.getElementById('pdp-tab-' + id);
    if (el) el.classList.add('active');
    if (btn) btn.classList.add('active');
  }

  // Expose functions for inline onclick
  window.ON_PDP = {
    selectFlavor: pdpSelectFlavor,
    switchTab:    pdpSwitchTab,
    addToCart:    pdpAddToCart
  };

  // Init PDP if on product page
  if (currentSku) {
    pdpSelectFlavor(currentSku);
  }

  // ── HOMEPAGE TICKER DUPLICATE ────────────────────────
  // Already handled by CSS animation — no JS needed

  // ── CART DRAWER (minimal) ────────────────────────────
  var cartCount = 0;
  function updateCartUI() {
    var el = document.getElementById('cart-count');
    if (el) el.textContent = cartCount;
  }

  // ── SMOOTH SCROLL FOR ANCHOR LINKS ──────────────────
  function smoothScrollToId(id) {
    var target = document.getElementById(id);
    if (!target) return false;
    var headerEl = document.getElementById('site-header');
    var offset = headerEl ? headerEl.offsetHeight + 8 : 8;
    var y = target.getBoundingClientRect().top + window.pageYOffset - offset;
    window.scrollTo({ top: y, behavior: 'smooth' });
    return true;
  }

  // Same-page hash links: href="#section"
  document.querySelectorAll('a[href^="#"]').forEach(function(a) {
    a.addEventListener('click', function(e) {
      if (smoothScrollToId(a.getAttribute('href').slice(1))) e.preventDefault();
    });
  });

  // Root-relative hash links: href="/#section"
  // On homepage: smooth scroll. On other pages: let browser navigate normally (it will jump on load).
  if (window.location.pathname === '/' || window.location.pathname === '') {
    document.querySelectorAll('a[href^="/#"]').forEach(function(a) {
      a.addEventListener('click', function(e) {
        var id = a.getAttribute('href').slice(2); // strip leading /#
        if (smoothScrollToId(id)) {
          e.preventDefault();
          history.pushState(null, '', a.getAttribute('href'));
        }
      });
    });
  }

  // On page load: if URL has a hash, scroll to it after layout settles
  if (window.location.hash) {
    setTimeout(function() {
      smoothScrollToId(window.location.hash.slice(1));
    }, 120);
  }

});
